(() => {
    const root = document.getElementById('hf-mobile-nav');
    if (!root || root.dataset.hfMobileInit === 'true') return;
    root.dataset.hfMobileInit = 'true';

    const openBtns = root.querySelectorAll('[data-hf-mobile-open]');
    const openBtn = openBtns[0] || null;
    const openSearchBtn = root.querySelector('[data-hf-mobile-open-search]');
    const productAtcBtn = root.querySelector('[data-hf-mobile-product-atc]');
    const defaultProductBar = root.querySelector('[data-hf-mobile-default-product-bar]');
    const stickyProductBar = root.querySelector('[data-hf-mobile-sticky-product-bar]');
    const searchScreen = root.querySelector('[data-hf-mobile-search-screen]');
    const closeSearchBtn = root.querySelector('[data-hf-mobile-close-search]') || document.querySelector('[data-hf-mobile-close-search]');
    const mobileSearchInput = root.querySelector('[data-hf-mobile-search-input]');
    const mobileSearchClear = root.querySelector('[data-hf-mobile-search-clear]');
    const mobileSearchDefault = root.querySelector('[data-hf-mobile-search-default]');
    const mobileSearchResults = root.querySelector('[data-hf-mobile-search-results]');
    const mobileSearchList = root.querySelector('[data-hf-mobile-search-list]');
    const mobileSearchViewAll = root.querySelector('[data-hf-mobile-search-view-all]');
    const mobileSearchEmpty = root.querySelector('[data-hf-mobile-search-empty]');
    const mobileSearchEmptyClear = root.querySelector('[data-hf-mobile-search-empty-clear]');
    const mobileSuggestedQueries = root.querySelectorAll('[data-hf-mobile-suggested-query]');
    const mobileRecentlyViewedBlock = root.querySelector('[data-hf-mobile-recently-viewed]');
    const mobileRecentlyViewedList = root.querySelector('[data-hf-mobile-recently-viewed-list]');
    const mobileCartCountEls = root.querySelectorAll('[data-hf-mobile-cart-count]');
        const cartLinks = root.querySelectorAll('[data-hf-mobile-cart-link]');
    const cartScreen = root.querySelector('[data-hf-mobile-cart-screen]') || document.querySelector('[data-hf-mobile-cart-screen]');
    const cartScreenInner = root.querySelector('.hf-mobile-nav__cart-screen-inner') || document.querySelector('.hf-mobile-nav__cart-screen-inner');
    const closeCartBtn = root.querySelector('[data-hf-mobile-close-cart]') || document.querySelector('[data-hf-mobile-close-cart]');
    const mobileCartEmpty = root.querySelector('[data-hf-mobile-cart-empty]') || document.querySelector('[data-hf-mobile-cart-empty]');
    const mobileCartFilled = root.querySelector('[data-hf-mobile-cart-filled]') || document.querySelector('[data-hf-mobile-cart-filled]');
    const mobileCartItems = root.querySelector('[data-hf-mobile-cart-items]') || document.querySelector('[data-hf-mobile-cart-items]');
    const mobileCartItemTemplate = root.querySelector('[data-hf-mobile-cart-item-template]') || document.querySelector('[data-hf-mobile-cart-item-template]');
    const mobileCartSubtotal = root.querySelector('[data-hf-mobile-cart-subtotal]') || document.querySelector('[data-hf-mobile-cart-subtotal]');
    const mobileCartTaxCopy = root.querySelector('[data-hf-mobile-cart-tax-copy]') || document.querySelector('[data-hf-mobile-cart-tax-copy]');
    const mobileCartShipping = root.querySelector('[data-hf-mobile-cart-shipping]') || document.querySelector('[data-hf-mobile-cart-shipping]');
    const mobileCartShippingCopy = root.querySelector('[data-hf-mobile-cart-shipping-copy]') || document.querySelector('[data-hf-mobile-cart-shipping-copy]');
    const mobileCartShippingProgress = root.querySelector('[data-hf-mobile-cart-shipping-progress]') || document.querySelector('[data-hf-mobile-cart-shipping-progress]');
    const mobileCartCheckout = root.querySelector('[data-hf-mobile-cart-checkout]') || document.querySelector('[data-hf-mobile-cart-checkout]');
    const mobileCartRecentlyViewedBlock = root.querySelector('[data-hf-mobile-cart-recently-viewed]') || document.querySelector('[data-hf-mobile-cart-recently-viewed]');
    const mobileCartRecentlyViewedList = root.querySelector('[data-hf-mobile-cart-recently-viewed-list]') || document.querySelector('[data-hf-mobile-cart-recently-viewed-list]');
    const overlay = root.querySelector('[data-hf-mobile-overlay]');
    const menu = root.querySelector('.hf-mobile-nav__menu');
    const menuInner = root.querySelector('.hf-mobile-nav__menu-inner');
    const searchScreenInner = root.querySelector('.hf-mobile-nav__search-screen-inner');
        const panels = root.querySelectorAll('[data-hf-mobile-panel]');
    const openSecondTriggers = root.querySelectorAll('[data-hf-mobile-open-second]');
    const backButtons = root.querySelectorAll('[data-hf-mobile-back]');
    const secondAccordionTriggers = root.querySelectorAll('[data-hf-mobile-second-accordion]');
    const secondAccordionItems = root.querySelectorAll('[data-hf-mobile-second-item]');
    const barLinks = root.querySelectorAll('.hf-mobile-nav__bar a.hf-mobile-nav__item');
    const barItems = root.querySelectorAll('.hf-mobile-nav__bar .hf-mobile-nav__item');
    const stickyBrand = root.querySelector('.hf-mobile-nav__sticky-brand');
    const bottomBar = root.querySelector('.hf-mobile-nav__bar');
    const mobileRecentlyViewedStorageKey = 'hfRecentlyViewed';
    let mobileSearchAbortController = null;
    let mobileSearchDebounceTimer = null;
    let mobileSearchFocusTimer = null;
    let lastBottomBarScrollY = window.scrollY || window.pageYOffset || 0;
    let productStickyObserver = null;
    let mobileLockedScrollY = 0;
    let mobilePageLockOwner = '';
    let mobileUsesFixedBodyLock = false;
    const isIOSWebKit = /iPad|iPhone|iPod/.test(navigator.userAgent)
      || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    const mobileCartProductDataCache = new Map();
    const mobileMemberDiscountEligibilityCache = new Map();
    let mobileCartRememberedDiscountCode = '';
    const MOBILE_MEMBER_DISCOUNT_COLLECTION_HANDLE = 'qualifies-for-members-discount';
    const MOBILE_MEMBER_DISCOUNT_URL = 'https://www.monodsports.com/pages/help-center#membership';

function getMobileProductStickyTrigger() {
  return document.querySelector('.buy-buttons')
    || document.querySelector('.product-form__buttons')
    || document.querySelector('.product-info__buy-buttons')
    || document.querySelector('.product-info__block-item[data-block-type="buy_buttons"]')
    || document.querySelector('[data-block-type="buy_buttons"]')
    || document.querySelector('buy-buttons')
    || document.querySelector('product-form');
}

function setProductStickyBarActive(isActive) {
  if (!defaultProductBar || !stickyProductBar) return;
  root.classList.toggle('is-sticky-product-bar-active', !!isActive);
}

function syncProductStickyBarObserver() {
  if (productStickyObserver) {
    productStickyObserver.disconnect();
    productStickyObserver = null;
  }

  setProductStickyBarActive(false);

  if (window.innerWidth > 989) return;
  if (!defaultProductBar || !stickyProductBar) return;

  const trigger = getMobileProductStickyTrigger();
  if (!trigger) return;

  productStickyObserver = new IntersectionObserver((entries) => {
    const entry = entries && entries[0];
    if (!entry) return;

    const shouldActivateSticky = entry.boundingClientRect.top <= (window.innerHeight * 0.45);

    setProductStickyBarActive(shouldActivateSticky);
  }, {
    root: null,
    threshold: 0,
    rootMargin: '0px 0px -55% 0px'
  });

  productStickyObserver.observe(trigger);
}

function runBottomBarIntroOnce() {
  if (!bottomBar) return;
  if (window.innerWidth > 989) return;

  const storageKey = 'hf-mobile-bar-intro-played';

  try {
    if (window.sessionStorage && sessionStorage.getItem(storageKey) === 'true') {
      return;
    }
  } catch (error) {}

  bottomBar.classList.add('is-intro-animating');

  window.setTimeout(() => {
    bottomBar.classList.remove('is-intro-animating');
  }, 980);

  try {
    if (window.sessionStorage) {
      sessionStorage.setItem(storageKey, 'true');
    }
  } catch (error) {}
}

    function syncBottomBarCompactState() {
  if (!bottomBar) return;
  if (window.innerWidth > 989) {
    root.classList.remove('is-bar-compact');
    lastBottomBarScrollY = window.scrollY || window.pageYOffset || 0;
    return;
  }

  if (root.classList.contains('is-open') || root.classList.contains('is-search-open') || root.classList.contains('is-cart-open')) {
    root.classList.remove('is-bar-compact');
    lastBottomBarScrollY = window.scrollY || window.pageYOffset || 0;
    return;
  }

  const currentScrollY = Math.max(0, window.scrollY || window.pageYOffset || 0);
  const scrollDelta = currentScrollY - lastBottomBarScrollY;
  const nearTop = currentScrollY < 24;

  if (nearTop || scrollDelta < -4) {
    root.classList.remove('is-bar-compact');
  } else if (currentScrollY > 24 && scrollDelta > 4) {
    root.classList.add('is-bar-compact');
  }

  lastBottomBarScrollY = currentScrollY;
}

function queueBottomBarCompactSync() {
  window.requestAnimationFrame(syncBottomBarCompactState);
}

function lockMobilePageScroll(owner) {
  if (!owner) return;
  if (window.innerWidth > 989) return;

  const scrollY = window.scrollY || window.pageYOffset || 0;

  if (!mobilePageLockOwner) {
    mobileLockedScrollY = scrollY;
  }

  mobilePageLockOwner = owner;

  document.documentElement.classList.add('hf-mobile-lock');
  document.body.classList.add('hf-mobile-lock');
  document.documentElement.style.overflow = 'hidden';
  document.body.style.overflow = 'hidden';
  mobileUsesFixedBodyLock = !isIOSWebKit;

  if (mobileUsesFixedBodyLock) {
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + mobileLockedScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }
}

function unlockMobilePageScroll(owner) {
  if (owner && mobilePageLockOwner && mobilePageLockOwner !== owner) return;

  const restoreY = mobileLockedScrollY;
  mobilePageLockOwner = '';

  document.documentElement.classList.remove('hf-mobile-lock');
  document.body.classList.remove('hf-mobile-lock');
  document.documentElement.style.overflow = '';
  document.body.style.overflow = '';
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.left = '';
  document.body.style.right = '';
  document.body.style.width = '';

  if (mobileUsesFixedBodyLock) {
    window.scrollTo(0, restoreY);
  }

  mobileUsesFixedBodyLock = false;
}

function getMobileVisibleViewportHeight() {
  const layoutHeight = Math.round(window.innerHeight || document.documentElement.clientHeight || 0);
  const visualHeight = Math.round((window.visualViewport && window.visualViewport.height) || 0);
  return Math.max(layoutHeight, visualHeight);
}

function getMobileVisibleViewportWidth() {
  const layoutWidth = Math.round(window.innerWidth || document.documentElement.clientWidth || 0);
  const visualWidth = Math.round((window.visualViewport && window.visualViewport.width) || 0);
  return Math.max(layoutWidth, visualWidth);
}

function syncMobileOverlayViewportBounds() {
  const viewportHeight = getMobileVisibleViewportHeight();
  const viewportWidth = getMobileVisibleViewportWidth();

  [menu, searchScreen, cartScreen].forEach((panel) => {
    if (!panel) return;
    panel.style.top = '0px';
    panel.style.left = '0px';
    panel.style.right = 'auto';
    panel.style.bottom = 'auto';
    panel.style.width = viewportWidth + 'px';
    panel.style.height = viewportHeight + 'px';
    panel.style.minHeight = viewportHeight + 'px';
  });

  if (menuInner) {
    menuInner.style.height = viewportHeight + 'px';
    menuInner.style.minHeight = viewportHeight + 'px';
  }

  if (searchScreenInner) {
    searchScreenInner.style.height = viewportHeight + 'px';
    searchScreenInner.style.minHeight = viewportHeight + 'px';
  }

  if (cartScreenInner) {
    cartScreenInner.style.height = viewportHeight + 'px';
    cartScreenInner.style.minHeight = viewportHeight + 'px';
  }
}

function clearMobileOverlayViewportBounds() {
  [menu, searchScreen, cartScreen].forEach((panel) => {
    if (!panel) return;
    panel.style.top = '';
    panel.style.left = '';
    panel.style.right = '';
    panel.style.bottom = '';
    panel.style.width = '';
    panel.style.height = '';
    panel.style.minHeight = '';
  });

  if (menuInner) {
    menuInner.style.height = '';
    menuInner.style.minHeight = '';
  }

  if (searchScreenInner) {
    searchScreenInner.style.height = '';
    searchScreenInner.style.minHeight = '';
  }

  if (cartScreenInner) {
    cartScreenInner.style.height = '';
    cartScreenInner.style.minHeight = '';
  }
}

function findTopAnnouncement() {
  const explicit = document.getElementById('shopify-section-sections--21769528475891__custom_liquid_WCEQda');
  if (explicit && explicit !== root && !root.contains(explicit)) return explicit;

  const candidates = [
    ...document.querySelectorAll('.shopify-section-group-header-group .shopify-section--custom-liquid'),
    ...document.querySelectorAll('.shopify-section-group-header-group [id*="custom_liquid"]'),
    ...document.querySelectorAll('[id*="custom_liquid"][class*="shopify-section--custom-liquid"]')
  ].filter((el) => el && el !== root && !root.contains(el));

  let best = null;
  let bestBottom = 0;

  candidates.forEach((el) => {
    const bottom = getVisibleTopBarBottom(el);
    if (bottom > bestBottom) {
      best = el;
      bestBottom = bottom;
    }
  });

  return best;
}

function getElementVisibleBottom(el) {
  if (!el) return 0;
  const rect = el.getBoundingClientRect();
  const style = window.getComputedStyle(el);
  const hidden = style.display === 'none' || style.visibility === 'hidden' || parseFloat(style.opacity || '1') === 0;
  if (hidden) return 0;
  if (rect.bottom <= 0 || rect.height <= 0 || rect.width <= 0) return 0;
  const viewportH = window.innerHeight || document.documentElement.clientHeight || 0;
  return Math.max(0, Math.round(Math.min(rect.bottom, viewportH)));
}

function getVisibleTopBarBottom(rootEl) {
  if (!rootEl) return 0;

  let bestBottom = getElementVisibleBottom(rootEl);
  const nodes = [rootEl, ...rootEl.querySelectorAll('*')];

  nodes.forEach((node) => {
    const style = window.getComputedStyle(node);
    const rect = node.getBoundingClientRect();
    const fixedLike = style.position === 'fixed' || style.position === 'sticky';
    const nearTop = rect.top <= 6;

    if (!fixedLike && !nearTop) return;

    const visibleBottom = getElementVisibleBottom(node);
    if (visibleBottom > bestBottom) {
      bestBottom = visibleBottom;
    }
  });

  return bestBottom;
}

function getTopAnnouncementOffset() {
  const announcement = findTopAnnouncement();
  if (!announcement) return 0;

  return getVisibleTopBarBottom(announcement);
}

function mountStickyBrandToBody() {
  if (!stickyBrand) return;

  if (window.innerWidth > 989 || root.classList.contains('is-search-open') || root.classList.contains('is-cart-open')) {
    stickyBrand.classList.add('is-hidden');
    stickyBrand.style.display = 'none';
    stickyBrand.style.opacity = '0';
    stickyBrand.style.visibility = 'hidden';
    stickyBrand.style.pointerEvents = 'none';
    return;
  }

  if (stickyBrand.parentNode !== document.body) {
    document.body.appendChild(stickyBrand);
  }

  stickyBrand.classList.remove('is-hidden');
  stickyBrand.style.display = 'inline-flex';
  stickyBrand.style.position = 'fixed';
  stickyBrand.style.zIndex = '2147483647';
  stickyBrand.style.opacity = '1';
  stickyBrand.style.visibility = 'visible';
  stickyBrand.style.pointerEvents = 'auto';
  stickyBrand.style.mixBlendMode = 'normal';
  stickyBrand.style.left = '18px';
}

function syncStickyBrand() {
  if (!stickyBrand) return;

  if (window.innerWidth > 989 || root.classList.contains('is-open') || root.classList.contains('is-search-open') || root.classList.contains('is-cart-open')) {
    stickyBrand.classList.add('is-hidden');
    stickyBrand.style.display = 'none';
    stickyBrand.style.opacity = '0';
    stickyBrand.style.visibility = 'hidden';
    stickyBrand.style.pointerEvents = 'none';
    return;
  }

    const expandedTop = 58;
const collapsedTop = 14;
const scrollY = window.scrollY || window.pageYOffset || 0;
const topPx = Math.max(collapsedTop, expandedTop - scrollY);

  mountStickyBrandToBody();

  stickyBrand.classList.remove('is-hidden');
  stickyBrand.style.display = 'inline-flex';
  stickyBrand.style.setProperty('top', topPx + 'px', 'important');
  stickyBrand.style.left = '18px';
  stickyBrand.style.mixBlendMode = 'normal';
  stickyBrand.style.opacity = '1';
  stickyBrand.style.visibility = 'visible';
  stickyBrand.style.pointerEvents = 'auto';

  const img = stickyBrand.querySelector('img');
  if (img) {
    img.style.setProperty('width', '120px', 'important');
    img.style.height = 'auto';
  }
}


    let panelAnimTimeout = null;

    function setPanel(panelKey, direction = 'forward') {
      const currentPanel = root.querySelector('[data-hf-mobile-panel].is-active');
      const nextPanel = root.querySelector('[data-hf-mobile-panel="' + panelKey + '"]');

      if (!nextPanel) return;
      if (currentPanel === nextPanel) return;

      if (panelAnimTimeout) {
        clearTimeout(panelAnimTimeout);
        panelAnimTimeout = null;
      }

      panels.forEach((panel) => {
        panel.classList.remove('is-entering', 'is-leaving', 'is-leaving-back', 'is-pre-enter');
      });

      if (currentPanel) {
        currentPanel.classList.add(direction === 'back' ? 'is-leaving-back' : 'is-leaving');
      }

      nextPanel.classList.add('is-active', 'is-pre-enter');

      void nextPanel.offsetHeight;

      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          nextPanel.classList.remove('is-pre-enter');
          nextPanel.classList.add('is-entering');
        });
      });

      panelAnimTimeout = window.setTimeout(() => {
        panels.forEach((panel) => {
          const isTarget = panel === nextPanel;
          panel.classList.toggle('is-active', isTarget);
          panel.classList.remove('is-entering', 'is-leaving', 'is-leaving-back', 'is-pre-enter');
        });
        panelAnimTimeout = null;
      }, 560);
    }

        function closeMobileSecondAccordions(scope = root, exceptItem = null) {
      const items = scope.querySelectorAll('[data-hf-mobile-second-item]');

      items.forEach((item) => {
        if (!item || item === exceptItem) return;

        item.classList.remove('is-open');

        const trigger = item.querySelector('[data-hf-mobile-second-accordion]');
        if (trigger) {
          trigger.setAttribute('aria-expanded', 'false');
        }
      });
    }

    function toggleMobileSecondAccordion(trigger) {
      if (!trigger) return;

      const item = trigger.closest('[data-hf-mobile-second-item]');
      if (!item) return;

      const children = item.querySelector('[data-hf-mobile-third-children]');
      if (!children) return;

      const currentPanel = trigger.closest('[data-hf-mobile-panel]') || root;
      const willOpen = !item.classList.contains('is-open');

      closeMobileSecondAccordions(currentPanel, willOpen ? item : null);

      item.classList.toggle('is-open', willOpen);
      trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    }

    function openMenu() {
  if (window.innerWidth > 989) return;
closeSearchPanel();
closeCartScreen();
root.classList.add('is-open');
  if (stickyBrand) stickyBrand.classList.add('is-hidden');
  lockMobilePageScroll('menu');
  if (menu) menu.setAttribute('aria-hidden', 'false');
  openBtns.forEach((button) => button.setAttribute('aria-label', 'Close menu'));
  root.classList.remove('is-bar-compact');
  setProductStickyBarActive(false);
  syncMobileOverlayViewportBounds();
  syncStickyBrand();
}

function closeMenu() {
  if (window.innerWidth > 989) {
    if (stickyBrand) {
      stickyBrand.classList.add('is-hidden');
      stickyBrand.style.display = 'none';
      stickyBrand.style.opacity = '0';
      stickyBrand.style.visibility = 'hidden';
      stickyBrand.style.pointerEvents = 'none';
    }
    return;
  }

  root.classList.remove('is-open');
    setPanel('root', 'back');
    closeMobileSecondAccordions();

  if (stickyBrand && !root.classList.contains('is-search-open') && !root.classList.contains('is-cart-open')) {
    stickyBrand.classList.remove('is-hidden');
  }

  unlockMobilePageScroll('menu');

  if (menu) menu.setAttribute('aria-hidden', 'true');
  openBtns.forEach((button) => button.setAttribute('aria-label', 'Open menu'));

  if (!root.classList.contains('is-search-open') && !root.classList.contains('is-cart-open')) {
    clearMobileOverlayViewportBounds();
    syncStickyBrand();
    queueBottomBarCompactSync();
    syncProductStickyBarObserver();
  }
}

function openSearchPanel(event) {
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }

  if (window.innerWidth > 989) return;
  if (!searchScreen) return;

  if (mobileSearchFocusTimer) {
    clearTimeout(mobileSearchFocusTimer);
    mobileSearchFocusTimer = null;
  }

  root.classList.remove('is-open', 'is-cart-open', 'is-bar-compact');
  root.classList.add('is-search-open');

  if (menu) menu.setAttribute('aria-hidden', 'true');
  if (cartScreen) cartScreen.setAttribute('aria-hidden', 'true');
  searchScreen.setAttribute('aria-hidden', 'false');

  lockMobilePageScroll('search');
  setProductStickyBarActive(false);
  syncMobileOverlayViewportBounds();
  syncStickyBrand();
  renderMobileRecentlyViewed();

  mobileSearchFocusTimer = window.setTimeout(() => {
    if (!root.classList.contains('is-search-open')) return;
    mobileSearchInput?.focus();
    mobileSearchFocusTimer = null;
  }, 80);
}

function closeSearchPanel(event) {
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }

  if (mobileSearchFocusTimer) {
    clearTimeout(mobileSearchFocusTimer);
    mobileSearchFocusTimer = null;
  }

  root.classList.remove('is-search-open');

  if (searchScreen) {
    searchScreen.setAttribute('aria-hidden', 'true');
  }

  if (mobileSearchInput) {
    mobileSearchInput.blur();
  }

  clearMobileSearchResults();

  if (!root.classList.contains('is-open') && !root.classList.contains('is-cart-open')) {
    unlockMobilePageScroll('search');
    clearMobileOverlayViewportBounds();
    syncStickyBrand();
    queueBottomBarCompactSync();
    syncProductStickyBarObserver();
  }
}

function getMobileProductForm() {
  return document.querySelector('product-form form[action*="/cart/add"]')
    || document.querySelector('form[action*="/cart/add"]');
}

function getMobileNativeAddToCartButton(form) {
  if (!form) return null;

  return form.querySelector('button[type="submit"]')
    || form.querySelector('[name="add"]')
    || form.querySelector('.product-form__submit');
}

function isMobileAddToCartForm(form) {
  if (!form || form.tagName !== 'FORM') return false;

  const action = form.getAttribute('action') || '';
  return action.indexOf('/cart/add') !== -1;
}

function setMobileAddToCartLoading(form, isLoading) {
  if (!form) return;

  const buttons = form.querySelectorAll('button[type="submit"], [name="add"], .product-form__submit');

  buttons.forEach((button) => {
    if (!button) return;

    if (isLoading) {
      if (!button.dataset.hfMobileWasDisabled) {
        button.dataset.hfMobileWasDisabled = button.disabled ? 'true' : 'false';
      }
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
    } else {
      button.removeAttribute('aria-busy');
      if (button.dataset.hfMobileWasDisabled === 'false') {
        button.disabled = false;
      }
      delete button.dataset.hfMobileWasDisabled;
    }
  });
}

function getMobileAddToCartErrorMessage(errorData) {
  if (!errorData) return 'Add to cart failed.';
  if (typeof errorData === 'string') return errorData;
  if (typeof errorData.description === 'string') return errorData.description;
  if (typeof errorData.message === 'string') return errorData.message;
  if (typeof errorData.status === 'string') return errorData.status;
  return 'Add to cart failed.';
}

async function addMobileFormToCart(form) {
  if (!isMobileAddToCartForm(form)) return false;
  if (window.innerWidth > 989) return false;
  if (form.dataset.hfMobileAddingToCart === 'true') return true;

  form.dataset.hfMobileAddingToCart = 'true';
  setMobileAddToCartLoading(form, true);

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      let errorData = null;
      try {
        errorData = await response.json();
      } catch (error) {}
      throw new Error(getMobileAddToCartErrorMessage(errorData));
    }

    await response.json();

    const cart = await loadMobileCart();
    if (cart && typeof cart.item_count === 'number') {
      setMobileCartCount(cart.item_count);
    } else {
      syncMobileCartCount();
    }

    openCartScreen();
    return true;
  } catch (error) {
    console.error('[HF mobile header] Add to cart failed:', error);
    syncMobileCartCount();
    loadMobileCart();
    return false;
  } finally {
    setMobileAddToCartLoading(form, false);
    delete form.dataset.hfMobileAddingToCart;
  }
}

function handleMobileAddToCartSubmit(event) {
  const form = event.target;
  if (!isMobileAddToCartForm(form)) return;
  if (window.innerWidth > 989) return;

  event.preventDefault();
  event.stopPropagation();

  addMobileFormToCart(form);
}

function triggerMobileProductAddToCart() {
  const form = getMobileProductForm();
  if (!form) return;

  if (window.innerWidth <= 989 && isMobileAddToCartForm(form)) {
    addMobileFormToCart(form);
    return;
  }

  const nativeButton = getMobileNativeAddToCartButton(form);
  if (nativeButton && nativeButton.disabled) return;

  if (nativeButton) {
    nativeButton.click();
    queueMobileCartCountSync(400);
    queueMobileCartCountSync(1200);
    return;
  }

  if (typeof form.requestSubmit === 'function') {
    form.requestSubmit();
    queueMobileCartCountSync(400);
    queueMobileCartCountSync(1200);
    return;
  }

  form.submit();
  queueMobileCartCountSync(400);
  queueMobileCartCountSync(1200);
}

function setMobileCartCount(count) {
  const safeCount = Math.max(0, Number(count) || 0);

  mobileCartCountEls.forEach((el) => {
    el.textContent = String(safeCount);
    el.hidden = safeCount < 1;
    el.setAttribute('aria-hidden', safeCount < 1 ? 'true' : 'false');
  });
}

function syncMobileCartCount() {
  if (!mobileCartCountEls.length) return;

  fetch('/cart.js', {
    headers: { Accept: 'application/json' }
  })
    .then((response) => {
      if (!response.ok) throw new Error('Cart fetch failed');
      return response.json();
    })
    .then((cart) => {
      setMobileCartCount(cart && typeof cart.item_count === 'number' ? cart.item_count : 0);
    })
    .catch(() => {});
}

function getMobileCartData() {
  return fetch('/cart.js', {
    headers: { Accept: 'application/json' }
  }).then((response) => {
    if (!response.ok) throw new Error('Cart fetch failed');
    return response.json();
  });
}

function renderMobileCartRecentlyViewed() {
  if (!mobileCartRecentlyViewedBlock || !mobileCartRecentlyViewedList) return;

  const productIds = getMobileRecentlyViewedIds();

  if (!productIds.length) {
    mobileCartRecentlyViewedList.innerHTML = '';
    mobileCartRecentlyViewedBlock.hidden = true;
    return;
  }

  Promise.all(productIds.map((productId) => getMobileProductDataById(productId))).then((products) => {
    const validProducts = products.filter(Boolean);
    mobileCartRecentlyViewedList.innerHTML = '';

    if (!validProducts.length) {
      mobileCartRecentlyViewedBlock.hidden = true;
      return;
    }

    validProducts.forEach((product) => {
      mobileCartRecentlyViewedList.appendChild(createMobileRecentlyViewedCard(product));
    });

    mobileCartRecentlyViewedBlock.hidden = false;
  }).catch(() => {
    mobileCartRecentlyViewedBlock.hidden = true;
  });
}

function getMobileCartLineVariantText(item) {
  if (!item) return '';

  if (item.variant_title && item.variant_title !== 'Default Title') {
    return item.variant_title;
  }

  if (Array.isArray(item.options_with_values)) {
    return item.options_with_values
      .map((option) => option && option.value ? String(option.value).trim() : '')
      .filter(Boolean)
      .join(' / ');
  }

  return '';
}

function getMobileCartLineDiscountData(item) {
  if (!item || !Array.isArray(item.line_level_discount_allocations) || !item.line_level_discount_allocations.length) {
    return null;
  }

  const titles = [];
  let totalAmount = 0;

  item.line_level_discount_allocations.forEach((allocation) => {
    if (!allocation) return;

    const amount = Number(allocation.amount || 0);
    if (amount > 0) {
      totalAmount += amount;
    }

    const title = allocation.discount_application && allocation.discount_application.title
      ? allocation.discount_application.title
      : allocation.title;

    if (title && titles.indexOf(title) === -1) {
      titles.push(title);
    }
  });

  if (!titles.length && totalAmount <= 0) return null;

  return {
    title: titles.join(', '),
    amountText: totalAmount > 0 ? ' (-' + getMobileSearchMoney(totalAmount) + ')' : ''
  };
}

function resetMobileCartDiscountBanners() {
  root.querySelectorAll('cart-discount-banner').forEach((banner) => {
    banner.hidden = true;
  });
}

function syncMobileCartDiscountFields(cart) {
  const appliedCodes = cart && Array.isArray(cart.discount_applications)
    ? cart.discount_applications
        .filter((application) => application && application.type === 'discount_code' && application.title)
        .map((application) => application.title)
        .join(',')
    : '';

  const fieldCode = getMobileCartDiscountCodeFromField();
  const codesToKeep = appliedCodes || fieldCode || mobileCartRememberedDiscountCode || '';

  if (codesToKeep) {
    mobileCartRememberedDiscountCode = codesToKeep;
  }

  root.querySelectorAll('[data-hf-mobile-cart-discount] input[name="discount"][type="hidden"]').forEach((input) => {
    input.value = codesToKeep;
  });

  syncMobileCartCheckoutDiscount(codesToKeep);
}

function getMobileCartDiscountCodeFromField() {
  const hiddenInput = root.querySelector('[data-hf-mobile-cart-discount] input[name="discount"][type="hidden"]')
    || document.querySelector('[data-hf-mobile-cart-discount] input[name="discount"][type="hidden"]');

  const visibleInput = root.querySelector('[data-hf-mobile-cart-discount] input:not([type="hidden"])')
    || document.querySelector('[data-hf-mobile-cart-discount] input:not([type="hidden"])');

  const hiddenCode = hiddenInput && hiddenInput.value ? String(hiddenInput.value).trim() : '';
  const visibleCode = visibleInput && visibleInput.value ? String(visibleInput.value).trim() : '';

  return hiddenCode || visibleCode || mobileCartRememberedDiscountCode || '';
}

function getMobileCartFirstDiscountCode(appliedCodes) {
  return String(appliedCodes || getMobileCartDiscountCodeFromField() || '')
    .split(',')
    .map((code) => code.trim())
    .filter(Boolean)[0] || '';
}

function getMobileCartCheckoutHref(appliedCodes) {
  const firstCode = getMobileCartFirstDiscountCode(appliedCodes);

  if (firstCode) {
    mobileCartRememberedDiscountCode = firstCode;
    return '/discount/' + encodeURIComponent(firstCode) + '?redirect=' + encodeURIComponent('/checkout');
  }

  return '/checkout';
}

function syncMobileCartCheckoutDiscount(appliedCodes) {
  if (!mobileCartCheckout) return;
  mobileCartCheckout.href = getMobileCartCheckoutHref(appliedCodes);
}

function handleMobileCartCheckoutClick(event) {
  if (window.innerWidth > 989) return;

  const checkoutTarget = event.target && event.target.closest
    ? event.target.closest('[data-hf-mobile-cart-checkout]')
    : mobileCartCheckout;

  if (!checkoutTarget) return;

  const href = getMobileCartCheckoutHref();
  checkoutTarget.href = href;

  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();

  window.location.assign(href);
}

function handleMobileCartDiscountCodeInput(event) {
  if (!isMobileCartDiscountInput(event.target)) return;

  const value = String(event.target.value || '').trim();
  if (!value) return;

  mobileCartRememberedDiscountCode = value;
  syncMobileCartCheckoutDiscount(value);
}

function isMobileCartDiscountInput(target) {
  return Boolean(
    target &&
    target.matches &&
    target.matches('[data-hf-mobile-cart-discount] input:not([type="hidden"])')
  );
}

function scrollMobileCartToDiscountField() {
  const body = root.querySelector('.hf-mobile-nav__cart-screen-body');
  if (!body) return;

  const scrollToBottom = () => {
    body.scrollTop = body.scrollHeight;
  };

  requestAnimationFrame(scrollToBottom);
  setTimeout(scrollToBottom, 120);
  setTimeout(scrollToBottom, 280);
}

function isMobileCartDiscountFocused() {
  return isMobileCartDiscountInput(document.activeElement);
}

function handleMobileCartDiscountFocusPrepare(event) {
  if (!isMobileCartDiscountInput(event.target)) return;
  if (event.type !== 'focusin') return;

  scrollMobileCartToDiscountField();
}

function getMobileCartLineImage(item) {
  if (!item) return '';
  if (item.featured_image && typeof item.featured_image.url === 'string') return item.featured_image.url;
  if (item.image && typeof item.image === 'string') return item.image;
  return '';
}

function getMobileCartLineSellingUnitPrice(item) {
  if (!item) return 0;

  if (typeof item.final_price === 'number') return item.final_price;
  if (typeof item.price === 'number') return item.price;

  const quantity = Number(item.quantity || 1);
  if (quantity > 0 && typeof item.final_line_price === 'number') {
    return Math.round(item.final_line_price / quantity);
  }

  if (quantity > 0 && typeof item.line_price === 'number') {
    return Math.round(item.line_price / quantity);
  }

  return 0;
}

function getMobileCartLineSellingLinePrice(item) {
  if (!item) return 0;

  if (typeof item.final_line_price === 'number') return item.final_line_price;
  if (typeof item.line_price === 'number') return item.line_price;

  return getMobileCartLineSellingUnitPrice(item) * Number(item.quantity || 1);
}

function getMobileCartLineCompareAt(item) {
  if (!item) return 0;

  const sellingUnitPrice = getMobileCartLineSellingUnitPrice(item);
  const directCompareAt = Number(
    item.variant_compare_at_price
    || item.compare_at_price
    || item.compare_at
    || 0
  );

  if (directCompareAt > sellingUnitPrice) {
    return directCompareAt;
  }

  if (typeof item.original_price === 'number' && item.original_price > sellingUnitPrice) {
    return item.original_price;
  }

  return 0;
}

function getMobileCartProductHandle(item) {
  if (!item) return '';
  if (item.handle) return item.handle;

  const url = item.url || '';
  if (url.indexOf('/products/') === -1) return '';

  return url.split('/products/').pop().split('?')[0].split('#')[0].split('/')[0];
}

function getMobileCartProductData(item) {
  const handle = getMobileCartProductHandle(item);
  if (!handle) return Promise.resolve(null);

  if (mobileCartProductDataCache.has(handle)) {
    return mobileCartProductDataCache.get(handle);
  }

  const promise = fetch('/products/' + encodeURIComponent(handle) + '.js', {
    headers: { Accept: 'application/json' }
  })
    .then((response) => {
      if (!response.ok) return null;
      return response.json();
    })
    .catch(() => null);

  mobileCartProductDataCache.set(handle, promise);
  return promise;
}

function getMobileCartVariantCompareAt(item, product) {
  if (!item || !product || !Array.isArray(product.variants)) return 0;

  const variantId = Number(item.variant_id || item.id || 0);
  if (!variantId) return 0;

  const variant = product.variants.find((entry) => Number(entry && entry.id ? entry.id : 0) === variantId);
  if (!variant) return 0;

  const compareAt = Number(variant.compare_at_price || 0);
  const sellingUnitPrice = getMobileCartLineSellingUnitPrice(item);

  return compareAt > sellingUnitPrice ? compareAt : 0;
}

function updateMobileCartLinePriceDisplay(item, priceEl, compareEl, compareAtUnitPrice) {
  if (!item || !priceEl) return;

  const quantity = Number(item.quantity || 1);
  const sellingLinePrice = getMobileCartLineSellingLinePrice(item);

  if (compareAtUnitPrice && compareAtUnitPrice > getMobileCartLineSellingUnitPrice(item)) {
    if (compareEl) {
      compareEl.textContent = getMobileSearchMoney(compareAtUnitPrice * quantity);
      compareEl.hidden = false;
    }

    priceEl.textContent = getMobileSearchMoney(sellingLinePrice);
    priceEl.classList.add('hf-mobile-nav__cart-item-price--sale');
    return;
  }

  if (compareEl) {
    compareEl.textContent = '';
    compareEl.hidden = true;
  }

  priceEl.textContent = getMobileSearchMoney(sellingLinePrice);
  priceEl.classList.remove('hf-mobile-nav__cart-item-price--sale');
}


function hydrateMobileCartLineCompareAt(item, priceEl, compareEl) {
  if (!item || !priceEl) return;

  const directCompareAt = getMobileCartLineCompareAt(item);
  if (directCompareAt) {
    updateMobileCartLinePriceDisplay(item, priceEl, compareEl, directCompareAt);
    return;
  }

  getMobileCartProductData(item).then((product) => {
    const variantCompareAt = getMobileCartVariantCompareAt(item, product);
    if (!variantCompareAt) return;
    updateMobileCartLinePriceDisplay(item, priceEl, compareEl, variantCompareAt);
  });
}

function getMobileMemberDiscountProductMap() {
  const dataNode = root.querySelector('[data-hf-member-discount-products]') || document.querySelector('[data-hf-member-discount-products]');
  if (!dataNode) return null;

  const raw = dataNode.textContent || dataNode.getAttribute('data-hf-member-discount-products') || '';
  if (!raw.trim()) return null;

  try {
    const parsed = JSON.parse(raw);
    const map = new Set();

    if (Array.isArray(parsed)) {
      parsed.forEach((entry) => {
        if (entry == null) return;

        if (typeof entry === 'string' || typeof entry === 'number') {
          map.add(String(entry));
          return;
        }

        if (typeof entry === 'object') {
          if (entry.id) map.add(String(entry.id));
          if (entry.product_id) map.add(String(entry.product_id));
          if (entry.handle) map.add(String(entry.handle));
        }
      });
    } else if (parsed && typeof parsed === 'object') {
      Object.keys(parsed).forEach((key) => {
        if (parsed[key]) map.add(String(key));
      });
    }

    return map.size ? map : null;
  } catch (error) {
    return null;
  }
}

function getMobileCartLineProductId(item) {
  if (!item) return '';
  return String(item.product_id || item.productId || item.product?.id || '');
}

function isMobileCartLineInMemberDiscountMap(item) {
  const map = getMobileMemberDiscountProductMap();
  if (!map || !item) return null;

  const productId = getMobileCartLineProductId(item);
  const handle = getMobileCartProductHandle(item);

  return Boolean(
    (productId && map.has(productId)) ||
    (handle && map.has(handle))
  );
}

function getMobileMemberDiscountEligibilityByHandle(handle) {
  const safeHandle = String(handle || '').trim();
  if (!safeHandle) return Promise.resolve(false);

  if (mobileMemberDiscountEligibilityCache.has(safeHandle)) {
    return mobileMemberDiscountEligibilityCache.get(safeHandle);
  }

  const expectedPath = '/collections/' + MOBILE_MEMBER_DISCOUNT_COLLECTION_HANDLE + '/products/' + safeHandle;
  const url = expectedPath;

  const promise = fetch(url, {
    credentials: 'same-origin',
    redirect: 'follow',
    headers: { Accept: 'text/html' }
  })
    .then((response) => {
      if (!response.ok) return false;

      try {
        const finalUrl = new URL(response.url, window.location.origin);
        return finalUrl.pathname.replace(/\/$/, '') === expectedPath;
      } catch (error) {
        return false;
      }
    })
    .catch(() => false);

  mobileMemberDiscountEligibilityCache.set(safeHandle, promise);
  return promise;
}

function isMobileMemberDiscountEligibleItem(item) {
  if (!item) return Promise.resolve(false);
  if (getMobileCartLineDiscountData(item)) return Promise.resolve(false);

  const mappedEligibility = isMobileCartLineInMemberDiscountMap(item);
  if (mappedEligibility !== null) return Promise.resolve(mappedEligibility);

  const handle = getMobileCartProductHandle(item);
  return getMobileMemberDiscountEligibilityByHandle(handle);
}

function renderMobileMemberDiscountMessage(memberMessage) {
  if (!memberMessage) return;

  memberMessage.innerHTML = '';

  const text = document.createElement('span');
  text.className = 'hf-mobile-nav__cart-item-member-message-text';
  text.textContent = 'YOU COULD SAVE 10% OFF THIS ITEM.';

  const link = document.createElement('a');
  link.className = 'hf-mobile-nav__cart-item-member-message-link';
  link.href = MOBILE_MEMBER_DISCOUNT_URL;
  link.textContent = 'LEARN HOW';

  memberMessage.appendChild(text);
  memberMessage.appendChild(document.createTextNode(' '));
  memberMessage.appendChild(link);
  memberMessage.hidden = false;
}

function hydrateMobileCartLineMemberDiscountMessage(item, memberMessage) {
  if (!memberMessage) return;

  memberMessage.hidden = true;
  memberMessage.innerHTML = '';

  if (getMobileCartLineDiscountData(item)) return;

  isMobileMemberDiscountEligibleItem(item).then((isEligible) => {
    if (!isEligible) return;
    if (!memberMessage.isConnected) return;
    if (getMobileCartLineDiscountData(item)) return;

    renderMobileMemberDiscountMessage(memberMessage);
  });
}

function createMobileCartLineItem(item, lineNumber) {
  if (!mobileCartItemTemplate) return null;

  const fragment = mobileCartItemTemplate.content.cloneNode(true);
  const lineEl = fragment.querySelector('.hf-mobile-nav__cart-item');
  if (!lineEl) return null;

  const imageLink = lineEl.querySelector('[data-hf-mobile-cart-line-link]');
  const image = lineEl.querySelector('[data-hf-mobile-cart-line-image]');
  const vendor = lineEl.querySelector('[data-hf-mobile-cart-line-vendor]');
  const titleLink = lineEl.querySelector('[data-hf-mobile-cart-line-title-link]');
  const title = lineEl.querySelector('[data-hf-mobile-cart-line-title]');
  const variant = lineEl.querySelector('[data-hf-mobile-cart-line-variant]');
  const discount = lineEl.querySelector('[data-hf-mobile-cart-line-discount]');
  const memberMessage = lineEl.querySelector('[data-hf-mobile-cart-line-member-message]');
  const removeBtn = lineEl.querySelector('[data-hf-mobile-cart-line-remove]');
  const decreaseBtn = lineEl.querySelector('[data-hf-mobile-cart-line-decrease]');
  const increaseBtn = lineEl.querySelector('[data-hf-mobile-cart-line-increase]');
  const qty = lineEl.querySelector('[data-hf-mobile-cart-line-qty]');
  const price = lineEl.querySelector('[data-hf-mobile-cart-line-price]');
  const compare = lineEl.querySelector('[data-hf-mobile-cart-line-price-compare]');

  const url = item.url || '/cart';
  const imageSrc = getMobileCartLineImage(item);
  const variantText = getMobileCartLineVariantText(item);
  const compareAt = getMobileCartLineCompareAt(item);

  if (imageLink) imageLink.href = url;
  if (titleLink) titleLink.href = url;
  if (title) title.textContent = item.product_title || item.title || '';
  if (vendor) vendor.textContent = item.vendor || '';

  if (image && imageSrc) {
    image.src = imageSrc;
    image.alt = item.product_title || item.title || 'Product image';
  }

  if (variant) {
    variant.textContent = variantText;
    variant.hidden = !variantText;
  }

    if (discount) {
    const discountData = getMobileCartLineDiscountData(item);
    if (discountData) {
      discount.textContent = discountData.title + discountData.amountText;
      discount.hidden = false;
    } else {
      discount.textContent = '';
      discount.hidden = true;
    }
  }

  if (memberMessage) {
    lineEl.appendChild(memberMessage);
  }

  hydrateMobileCartLineMemberDiscountMessage(item, memberMessage);

  if (qty) {
    qty.textContent = String(item.quantity || 0);
  }

  if (price) {
    updateMobileCartLinePriceDisplay(item, price, compare, compareAt);
    hydrateMobileCartLineCompareAt(item, price, compare);
  }

  const currentQty = Number(item.quantity || 0);

  if (decreaseBtn) {
    decreaseBtn.disabled = currentQty <= 1;
    decreaseBtn.addEventListener('click', () => {
      changeMobileCartLineQuantity(lineNumber, Math.max(0, currentQty - 1));
    });
  }

  if (increaseBtn) {
    increaseBtn.addEventListener('click', () => {
      changeMobileCartLineQuantity(lineNumber, currentQty + 1);
    });
  }

  if (removeBtn) {
    removeBtn.addEventListener('click', () => {
      changeMobileCartLineQuantity(lineNumber, 0);
    });
  }

  return lineEl;
}

function renderMobileCartShipping(cart) {
  if (!mobileCartShipping || !mobileCartShippingCopy || !mobileCartShippingProgress) return;

  const thresholdCents = 9900;
  const totalCents = Number(cart && typeof cart.total_price === 'number' ? cart.total_price : 0);

  mobileCartShipping.hidden = false;

  if (totalCents >= thresholdCents) {
    mobileCartShippingCopy.textContent = 'You have qualified for free shipping.';
    mobileCartShippingProgress.style.width = '100%';
    return;
  }

  const remaining = Math.max(0, thresholdCents - totalCents);
  mobileCartShippingCopy.textContent = getMobileSearchMoney(remaining) + ' away from free shipping';
  mobileCartShippingProgress.style.width = Math.max(8, Math.min(100, (totalCents / thresholdCents) * 100)) + '%';
}

function renderMobileCart(cart) {
  if (!mobileCartEmpty || !mobileCartFilled || !mobileCartItems || !mobileCartSubtotal) return;

  const itemCount = Number(cart && typeof cart.item_count === 'number' ? cart.item_count : 0);
  setMobileCartCount(itemCount);
  syncMobileCartDiscountFields(cart);

  mobileCartItems.innerHTML = '';

  if (!itemCount || !Array.isArray(cart.items) || !cart.items.length) {
    mobileCartEmpty.hidden = false;
    mobileCartFilled.hidden = true;
    syncMobileCartCheckoutDiscount('');
    renderMobileCartRecentlyViewed();
    return;
  }

  mobileCartEmpty.hidden = true;
  mobileCartFilled.hidden = false;

  cart.items.forEach((item, index) => {
    const lineEl = createMobileCartLineItem(item, index + 1);
    if (lineEl) {
      mobileCartItems.appendChild(lineEl);
    }
  });

  mobileCartSubtotal.textContent = getMobileSearchMoney(typeof cart.total_price === 'number' ? cart.total_price : 0);

  if (mobileCartTaxCopy) {
    mobileCartTaxCopy.textContent = 'Taxes and shipping calculated at checkout.';
  }

  renderMobileCartShipping(cart);
}

function loadMobileCart() {
  return getMobileCartData()
    .then((cart) => {
      renderMobileCart(cart);
      return cart;
    })
    .catch(() => null);
}

function openCartScreen(event) {
  if (window.innerWidth > 989) return;
  root.classList.remove('is-open', 'is-search-open');
  if (menu) menu.setAttribute('aria-hidden', 'true');
  if (searchScreen) searchScreen.setAttribute('aria-hidden', 'true');
  if (!cartScreen) return;

  root.classList.add('is-cart-open');
  cartScreen.setAttribute('aria-hidden', 'false');
  lockMobilePageScroll('cart');

  if (stickyBrand) {
    stickyBrand.classList.add('is-hidden');
    stickyBrand.style.display = 'none';
    stickyBrand.style.opacity = '0';
    stickyBrand.style.visibility = 'hidden';
    stickyBrand.style.pointerEvents = 'none';
  }

  syncStickyBrand();
  syncMobileOverlayViewportBounds();
  if (cartScreen) loadMobileCart();
}

function closeCartScreen(event) {
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }

  root.classList.remove('is-cart-open');

  if (cartScreen) {
    cartScreen.setAttribute('aria-hidden', 'true');
  }

  if (!root.classList.contains('is-open') && !root.classList.contains('is-search-open')) {
    unlockMobilePageScroll('cart');
    clearMobileOverlayViewportBounds();
    syncStickyBrand();
    queueBottomBarCompactSync();
    syncProductStickyBarObserver();
  }
}

function changeMobileCartLineQuantity(lineNumber, quantity) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify({
      line: lineNumber,
      quantity
    })
  })
    .then((response) => {
      if (!response.ok) throw new Error('Cart update failed');
      return response.json();
    })
    .then((cart) => {
      renderMobileCart(cart);
      setMobileCartCount(cart && typeof cart.item_count === 'number' ? cart.item_count : 0);
    })
    .catch(() => {
      syncMobileCartCount();
      loadMobileCart();
    });
}

function queueMobileCartCountSync(delay = 0) {
  window.setTimeout(() => {
    syncMobileCartCount();
  }, delay);
}

    function clearMobileSearchResults() {
      if (mobileSearchAbortController) {
        mobileSearchAbortController.abort();
        mobileSearchAbortController = null;
      }

      if (mobileSearchDebounceTimer) {
        clearTimeout(mobileSearchDebounceTimer);
        mobileSearchDebounceTimer = null;
      }

      if (mobileSearchList) {
        mobileSearchList.innerHTML = '';
      }

      if (mobileSearchResults) {
        mobileSearchResults.hidden = true;
      }

      if (mobileSearchEmpty) {
        mobileSearchEmpty.hidden = true;
      }

      if (mobileSearchDefault) {
        mobileSearchDefault.hidden = false;
      }
    }

    function resetMobileSearch() {
      if (mobileSearchInput) {
        mobileSearchInput.value = '';
      }

      clearMobileSearchResults();
      renderMobileRecentlyViewed();
    }

    function extractMobileRecentlyViewedId(value) {
      if (value == null) return 0;

      if (typeof value === 'number' && Number.isFinite(value)) {
        return Math.max(0, Math.round(value));
      }

      if (typeof value === 'string') {
        const trimmed = value.trim();
        if (!trimmed) return 0;

        if (/^\d+$/.test(trimmed)) {
          return Number(trimmed);
        }

        if (trimmed.charAt(0) === '{' || trimmed.charAt(0) === '[') {
          try {
            return extractMobileRecentlyViewedId(JSON.parse(trimmed));
          } catch (error) {
            return 0;
          }
        }

        return 0;
      }

      if (Array.isArray(value)) {
        for (const item of value) {
          const id = extractMobileRecentlyViewedId(item);
          if (id) return id;
        }
        return 0;
      }

      if (typeof value === 'object') {
        return extractMobileRecentlyViewedId(
          value.product_id ||
          value.productId ||
          value.id ||
          value.product?.id ||
          value.product?.product_id ||
          value.product?.productId
        );
      }

      return 0;
    }

    function getMobileRecentlyViewedIds() {
      const candidateKeys = [
        mobileRecentlyViewedStorageKey,
        'recentlyViewed',
        'recently_viewed',
        'theme:recently-viewed-products',
        'theme:recentlyViewedProducts',
        'product-recently-viewed',
        'products_recently_viewed'
      ];

      function extractIds(parsed) {
        if (!parsed) return [];

        if (Array.isArray(parsed)) {
          return parsed.map(extractMobileRecentlyViewedId).filter(Boolean);
        }

        if (typeof parsed === 'object') {
          const likelyArrays = [
            parsed.items,
            parsed.products,
            parsed.ids,
            parsed.recentlyViewed,
            parsed.recently_viewed,
            parsed.data
          ];

          for (const value of likelyArrays) {
            if (Array.isArray(value)) {
              const ids = value.map(extractMobileRecentlyViewedId).filter(Boolean);
              if (ids.length) return ids;
            }
          }

          const singleId = extractMobileRecentlyViewedId(parsed);
          if (singleId) return [singleId];
        }

        return [];
      }

      for (const key of candidateKeys) {
        try {
          const raw = window.localStorage.getItem(key);
          if (!raw) continue;

          let parsed = null;
          try {
            parsed = JSON.parse(raw);
          } catch (error) {
            parsed = raw;
          }

          const ids = extractIds(parsed);
          if (ids.length) {
            return Array.from(new Set(ids)).slice(0, 8);
          }
        } catch (error) {}
      }

      return [];
    }

    function getMobileProductDataById(productId) {
      if (!productId) return Promise.resolve(null);

      return fetch('/search/suggest.json?q=id:' + encodeURIComponent(String(productId)) + '&resources[type]=product&resources[limit]=1', {
        headers: { Accept: 'application/json' }
      })
        .then((response) => {
          if (!response.ok) return null;
          return response.json();
        })
        .then((results) => {
          const products = results && results.resources && results.resources.results && Array.isArray(results.resources.results.products)
            ? results.resources.results.products
            : [];

          const first = products[0];
          const handle = getMobileProductHandle(first);
          if (!handle) return null;

          return fetch('/products/' + handle + '.js', {
            headers: { Accept: 'application/json' }
          })
            .then((response) => {
              if (!response.ok) return null;
              return response.json();
            })
            .catch(() => null);
        })
        .catch(() => null);
    }

    function createMobileRecentlyViewedCard(product) {
      const item = document.createElement('div');
      item.className = 'product-list__item snap-start';

      const link = document.createElement('a');
      link.href = product.url || '#';
      link.className = 'product-card product-card--horizontal';

      const imageWrap = document.createElement('div');
      imageWrap.className = 'product-card__figure';

      if (product.featured_image) {
        const image = document.createElement('img');
        image.src = typeof product.featured_image === 'string' ? product.featured_image : (product.featured_image.src || product.featured_image.url || '');
        image.alt = product.title || '';
        image.loading = 'lazy';
        image.className = 'product-card__image';
        imageWrap.appendChild(image);
      }

      const content = document.createElement('div');
      content.className = 'product-card__info v-stack gap-1';

      if (product.vendor) {
        const vendor = document.createElement('span');
        vendor.className = 'text-sm text-subdued';
        vendor.textContent = product.vendor;
        content.appendChild(vendor);
      }

      const title = document.createElement('span');
      title.className = 'text-sm';
      title.textContent = product.title || '';
      content.appendChild(title);

      if (typeof product.price === 'number') {
        const compareAtCents = typeof product.compare_at_price === 'number' && product.compare_at_price > product.price
          ? product.compare_at_price
          : null;

        const priceWrap = document.createElement('span');
        priceWrap.className = 'hf-mobile-nav__search-result-price-wrap';

        if (typeof compareAtCents === 'number') {
          const compareAt = document.createElement('span');
          compareAt.className = 'hf-mobile-nav__search-result-price hf-mobile-nav__search-result-price--compare';
          compareAt.textContent = getMobileSearchMoney(compareAtCents);
          priceWrap.appendChild(compareAt);
        }

        const price = document.createElement('span');
        price.className = 'hf-mobile-nav__search-result-price' + (typeof compareAtCents === 'number' ? ' hf-mobile-nav__search-result-price--sale' : '');
        price.textContent = getMobileSearchMoney(product.price);
        priceWrap.appendChild(price);

        content.appendChild(priceWrap);
      }

      const swatches = createMobileColorSwatches(getMobileColorVariantImages(product));
      if (swatches) {
        content.appendChild(swatches);
      }

      link.appendChild(imageWrap);
      link.appendChild(content);
      item.appendChild(link);
      return item;
    }

    function renderMobileRecentlyViewed() {
      if (!mobileRecentlyViewedBlock || !mobileRecentlyViewedList) return;

      const productIds = getMobileRecentlyViewedIds();

      if (!productIds.length) {
        mobileRecentlyViewedList.innerHTML = '';
        mobileRecentlyViewedBlock.hidden = true;
        return;
      }

      Promise.all(productIds.map((productId) => getMobileProductDataById(productId))).then((products) => {
        const validProducts = products.filter(Boolean);

        mobileRecentlyViewedList.innerHTML = '';

        if (!validProducts.length) {
          mobileRecentlyViewedBlock.hidden = true;
          return;
        }

        validProducts.forEach((product) => {
          mobileRecentlyViewedList.appendChild(createMobileRecentlyViewedCard(product));
        });

        mobileRecentlyViewedBlock.hidden = false;
      });
    }

        function getMobileSearchMoney(cents) {
      if (typeof cents !== 'number') return '';
      return window.Shopify && Shopify.formatMoney
        ? Shopify.formatMoney(cents, window.theme && theme.moneyFormat ? theme.moneyFormat : undefined)
        : '$' + (cents / 100).toFixed(2);
    }

    function getMobileProductHandle(product) {
      if (!product) return '';
      if (product.handle) return product.handle;
      if (product.url && product.url.indexOf('/products/') > -1) {
        return product.url.split('/products/').pop().split('?')[0].split('#')[0];
      }
      return '';
    }

    function getMobileColorVariantImages(fullProduct) {
      if (!fullProduct || !Array.isArray(fullProduct.options) || !Array.isArray(fullProduct.variants)) return [];

      const colorOption = fullProduct.options.find((option) => {
        const name = String(option && option.name ? option.name : '').trim().toLowerCase();
        return name === 'color' || name === 'colour';
      });

      if (!colorOption) return [];

      const position = Number(colorOption.position || 0);
      if (!position) return [];

      const key = 'option' + position;
      const seen = new Set();
      const images = [];

      fullProduct.variants.forEach((variant) => {
        const rawValue = variant && variant[key] ? String(variant[key]).trim() : '';
        if (!rawValue) return;

        const normalized = rawValue.toLowerCase();
        if (seen.has(normalized)) return;

        let resolvedSrc = '';

        if (variant && variant.featured_image && typeof variant.featured_image.src === 'string') {
          resolvedSrc = variant.featured_image.src;
        } else if (variant && variant.featured_image && typeof variant.featured_image.url === 'string') {
          resolvedSrc = variant.featured_image.url;
        } else if (variant && variant.image_id && Array.isArray(fullProduct.images)) {
          const matchedImage = fullProduct.images.find((image) => Number(image && image.id ? image.id : 0) === Number(variant.image_id || 0));
          if (typeof matchedImage === 'string') {
            resolvedSrc = matchedImage;
          } else if (matchedImage && typeof matchedImage.src === 'string') {
            resolvedSrc = matchedImage.src;
          } else if (matchedImage && typeof matchedImage.url === 'string') {
            resolvedSrc = matchedImage.url;
          }
        }

        if (!resolvedSrc && Array.isArray(fullProduct.images) && fullProduct.images.length) {
          const firstImage = fullProduct.images[0];
          if (typeof firstImage === 'string') {
            resolvedSrc = firstImage;
          } else if (firstImage && typeof firstImage.src === 'string') {
            resolvedSrc = firstImage.src;
          } else if (firstImage && typeof firstImage.url === 'string') {
            resolvedSrc = firstImage.url;
          }
        }

        seen.add(normalized);
        if (resolvedSrc) {
          images.push({ color: rawValue, src: resolvedSrc });
        }
      });

      return images;
    }

    function createMobileColorSwatches(items) {
      if (!Array.isArray(items) || !items.length) return null;

      const wrap = document.createElement('span');
      wrap.className = 'hf-mobile-nav__search-result-swatches';

      items.slice(0, 5).forEach((item) => {
        const swatch = document.createElement('span');
        swatch.className = 'hf-mobile-nav__search-result-swatch';
        swatch.setAttribute('aria-label', item.color || 'Variant image');
        swatch.setAttribute('title', item.color || '');

        const image = document.createElement('img');
        image.className = 'hf-mobile-nav__search-result-swatch-image';
        image.src = item.src;
        image.alt = item.color || '';
        image.loading = 'lazy';

        swatch.appendChild(image);
        wrap.appendChild(swatch);
      });

      if (items.length > 5) {
        const more = document.createElement('span');
        more.className = 'hf-mobile-nav__search-result-swatch hf-mobile-nav__search-result-swatch--more';
        more.textContent = '+' + (items.length - 5);
        wrap.appendChild(more);
      }

      return wrap;
    }

        function renderMobileSearchResults(results, query) {
      if (!mobileSearchList || !mobileSearchResults || !mobileSearchDefault || !mobileSearchEmpty || !mobileSearchViewAll) return;

      mobileSearchList.innerHTML = '';

      const items = results && Array.isArray(results.resources && results.resources.results && results.resources.results.products)
        ? results.resources.results.products
        : [];

      if (!items.length) {
        mobileSearchResults.hidden = true;
        mobileSearchDefault.hidden = true;
        mobileSearchEmpty.hidden = false;
        return;
      }

      Promise.all(items.map((product) => {
        const handle = getMobileProductHandle(product);
        if (!handle) return Promise.resolve({ product, fullProduct: null });

        return fetch('/products/' + handle + '.js')
          .then((response) => {
            if (!response.ok) return { product, fullProduct: null };
            return response.json().then((fullProduct) => ({ product, fullProduct }));
          })
          .catch(() => ({ product, fullProduct: null }));
      })).then((resolvedItems) => {
        mobileSearchList.innerHTML = '';

        resolvedItems.forEach(({ product, fullProduct }) => {
          const li = document.createElement('li');
          li.className = 'hf-mobile-nav__search-list-item';

          const link = document.createElement('a');
          link.className = 'hf-mobile-nav__search-result';
          link.href = product.url || '#';

          if (product.featured_image && product.featured_image.url) {
            const imageWrap = document.createElement('span');
            imageWrap.className = 'hf-mobile-nav__search-result-image-wrap';

            const image = document.createElement('img');
            image.className = 'hf-mobile-nav__search-result-image';
            image.src = product.featured_image.url;
            image.alt = product.title || '';
            image.loading = 'lazy';
            imageWrap.appendChild(image);
            link.appendChild(imageWrap);
          }

          const copy = document.createElement('span');
          copy.className = 'hf-mobile-nav__search-result-copy';

          if (product.vendor) {
            const vendor = document.createElement('span');
            vendor.className = 'hf-mobile-nav__search-result-vendor';
            vendor.textContent = product.vendor;
            copy.appendChild(vendor);
          }

          const title = document.createElement('span');
          title.className = 'hf-mobile-nav__search-result-title';
          title.textContent = product.title || '';
          copy.appendChild(title);

          const priceCents = fullProduct && typeof fullProduct.price === 'number'
            ? fullProduct.price
            : product.price && typeof product.price.min === 'number'
              ? product.price.min
              : null;

          const compareAtCents = fullProduct && typeof fullProduct.compare_at_price === 'number' && fullProduct.compare_at_price > priceCents
            ? fullProduct.compare_at_price
            : null;

          if (typeof priceCents === 'number') {
            const priceWrap = document.createElement('span');
            priceWrap.className = 'hf-mobile-nav__search-result-price-wrap';

            if (typeof compareAtCents === 'number') {
              const compareAt = document.createElement('span');
              compareAt.className = 'hf-mobile-nav__search-result-price hf-mobile-nav__search-result-price--compare';
              compareAt.textContent = getMobileSearchMoney(compareAtCents);
              priceWrap.appendChild(compareAt);
            }

            const price = document.createElement('span');
            price.className = 'hf-mobile-nav__search-result-price' + (typeof compareAtCents === 'number' ? ' hf-mobile-nav__search-result-price--sale' : '');
            price.textContent = getMobileSearchMoney(priceCents);
            priceWrap.appendChild(price);

            copy.appendChild(priceWrap);
          }

          const colorValues = getMobileColorVariantImages(fullProduct);
          const swatches = createMobileColorSwatches(colorValues);
          if (swatches) {
            copy.appendChild(swatches);
          }

          link.appendChild(copy);
          li.appendChild(link);
          mobileSearchList.appendChild(li);
        });

        mobileSearchViewAll.href = '/search?q=' + encodeURIComponent(query) + '&type=product';
        mobileSearchDefault.hidden = true;
        mobileSearchEmpty.hidden = true;
        mobileSearchResults.hidden = false;
      });
    }

    function performMobilePredictiveSearch(query) {
      const trimmed = (query || '').trim();

      if (!trimmed) {
        clearMobileSearchResults();
        return;
      }

      if (mobileSearchDebounceTimer) {
        clearTimeout(mobileSearchDebounceTimer);
      }

      mobileSearchDebounceTimer = window.setTimeout(() => {
        if (mobileSearchAbortController) {
          mobileSearchAbortController.abort();
        }

        mobileSearchAbortController = new AbortController();

        fetch('/search/suggest.json?q=' + encodeURIComponent(trimmed) + '&resources[type]=product&resources[limit]=8', {
          signal: mobileSearchAbortController.signal,
          headers: { Accept: 'application/json' }
        })
          .then((response) => {
            if (!response.ok) throw new Error('Search failed');
            return response.json();
          })
          .then((results) => {
            renderMobileSearchResults(results, trimmed);
          })
          .catch((error) => {
            if (error && error.name === 'AbortError') return;
            if (mobileSearchResults) mobileSearchResults.hidden = true;
            if (mobileSearchDefault) mobileSearchDefault.hidden = true;
            if (mobileSearchEmpty) mobileSearchEmpty.hidden = false;
          });
      }, 140);
    }

        openBtns.forEach((button) => {
  button.addEventListener('click', (event) => {
    if (window.innerWidth > 989) return;
    event.preventDefault();
    event.stopPropagation();

    if (root.classList.contains('is-open')) {
      closeMenu();
    } else {
      openMenu();
    }
  });
});
    openSearchBtn?.addEventListener('click', openSearchPanel);
    cartLinks.forEach((link) => {
  link.addEventListener('click', (event) => {
    if (window.innerWidth > 989) return;
    event.preventDefault();
    event.stopPropagation();
    openCartScreen(event);
  });
});



    closeSearchBtn?.addEventListener('click', closeSearchPanel);
    closeCartBtn?.addEventListener('click', closeCartScreen);
    mobileCartCheckout?.addEventListener('click', handleMobileCartCheckoutClick, true);
    document.addEventListener('click', handleMobileCartCheckoutClick, true);
    document.addEventListener('input', handleMobileCartDiscountCodeInput, true);
    document.addEventListener('change', handleMobileCartDiscountCodeInput, true);


    productAtcBtn?.addEventListener('click', (event) => {
      if (window.innerWidth <= 989) {
        event.preventDefault();
        event.stopPropagation();
      }
      triggerMobileProductAddToCart();
    });

    document.addEventListener('submit', handleMobileAddToCartSubmit, true);
    overlay?.addEventListener('click', (event) => {
  event.preventDefault();
  event.stopPropagation();
  closeMenu();
  closeSearchPanel(event);
  closeCartScreen(event);
});
    barLinks.forEach((link) => {
      link.addEventListener('click', () => {
        closeMenu();
      });
    });
    barItems.forEach((item) => {
      item.addEventListener('touchstart', () => {}, { passive: true });
    });


    let stickyBrandRaf = null;
    function queueStickyBrandSync() {
  if (stickyBrandRaf) return;
  stickyBrandRaf = window.requestAnimationFrame(() => {
    stickyBrandRaf = null;
    syncStickyBrand();
  });
}

        window.addEventListener('load', () => {
      queueStickyBrandSync();
      queueBottomBarCompactSync();
      syncProductStickyBarObserver();
    });
    window.addEventListener('resize', () => {
      queueStickyBrandSync();
      queueBottomBarCompactSync();
      syncProductStickyBarObserver();

      if (root.classList.contains('is-cart-open') && isMobileCartDiscountFocused()) {
        scrollMobileCartToDiscountField();
        return;
      }

      if (root.classList.contains('is-open') || root.classList.contains('is-search-open') || root.classList.contains('is-cart-open')) {
        syncMobileOverlayViewportBounds();
      }
    });
    window.addEventListener('scroll', () => {
      queueStickyBrandSync();
      queueBottomBarCompactSync();
    }, { passive: true });
    window.addEventListener('orientationchange', () => {
      queueStickyBrandSync();
      queueBottomBarCompactSync();
      syncProductStickyBarObserver();
    });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', () => {
        queueStickyBrandSync();
        queueBottomBarCompactSync();
        syncProductStickyBarObserver();

        if (root.classList.contains('is-cart-open') && isMobileCartDiscountFocused()) {
          scrollMobileCartToDiscountField();
          return;
        }

        if (root.classList.contains('is-open') || root.classList.contains('is-search-open') || root.classList.contains('is-cart-open')) {
          syncMobileOverlayViewportBounds();
        }
      });
    }
    queueStickyBrandSync();
    queueBottomBarCompactSync();
    syncProductStickyBarObserver();
syncMobileCartCount();
if (cartScreen) loadMobileCart();
runBottomBarIntroOnce();
renderMobileRecentlyViewed();
    window.addEventListener('pageshow', () => {
      queueStickyBrandSync();
      queueBottomBarCompactSync();
      syncProductStickyBarObserver();
      syncMobileCartCount();
      renderMobileRecentlyViewed();
      if (cartScreen) loadMobileCart();
    });
    window.debugMobileStickyBrand = function () {
  const announcement = findTopAnnouncement();
  const announcementBottom = announcement ? getVisibleTopBarBottom(announcement) : 0;
  const brandRect = stickyBrand ? stickyBrand.getBoundingClientRect() : null;
  console.log('HF mobile sticky brand debug', {
    viewportWidth: window.innerWidth,
    announcement: announcement ? {
      tag: announcement.tagName,
      id: announcement.id || null,
      className: announcement.className || null,
      bottom: announcementBottom
    } : null,
    brand: brandRect ? {
      top: Math.round(brandRect.top),
      bottom: Math.round(brandRect.bottom),
      left: Math.round(brandRect.left)
    } : null,
    inlineTop: stickyBrand ? stickyBrand.style.top : null,
    parentTag: stickyBrand && stickyBrand.parentNode ? stickyBrand.parentNode.tagName : null,
    display: stickyBrand ? getComputedStyle(stickyBrand).display : null
  });
};

    openSecondTriggers.forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        if (window.innerWidth > 989) return;
        event.preventDefault();
        event.stopPropagation();

        const index = trigger.getAttribute('data-hf-mobile-open-second');
        setPanel(`second-${index}`, 'forward');
      });
    });

    backButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        if (window.innerWidth > 989) return;
        event.preventDefault();
        event.stopPropagation();

        closeMobileSecondAccordions();
        const panelKey = button.getAttribute('data-hf-mobile-back') || 'root';
        setPanel(panelKey, 'back');
      });
    });

    secondAccordionTriggers.forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        if (window.innerWidth > 989) return;
        event.preventDefault();
        event.stopPropagation();
        toggleMobileSecondAccordion(trigger);
      });
    });

    mobileSearchInput?.addEventListener('input', (event) => {
      performMobilePredictiveSearch(event.target.value || '');
    });

    mobileSearchClear?.addEventListener('click', () => {
      resetMobileSearch();
      mobileSearchInput?.focus();
    });

    mobileSearchEmptyClear?.addEventListener('click', () => {
      resetMobileSearch();
      mobileSearchInput?.focus();
    });

    mobileSuggestedQueries.forEach((button) => {
      button.addEventListener('click', () => {
        const query = button.getAttribute('data-hf-mobile-suggested-query') || '';
        if (mobileSearchInput) {
          mobileSearchInput.value = query;
        }
        performMobilePredictiveSearch(query);
      });
    });

    document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  if (root.classList.contains('is-open')) {
    closeMenu();
  }
  if (root.classList.contains('is-search-open')) {
  closeSearchPanel();
}
if (root.classList.contains('is-cart-open')) {
  closeCartScreen();
}
});

        document.addEventListener('cart:refresh', () => {
      resetMobileCartDiscountBanners();
      loadMobileCart();
    });

    document.addEventListener('cart:change', () => {
      loadMobileCart();
    });

    document.addEventListener('focusin', handleMobileCartDiscountFocusPrepare, true);

    document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') {
    syncMobileCartCount();
    if (cartScreen) loadMobileCart();
  }
});

    root.addEventListener('click', (event) => {
      const secondTrigger = event.target.closest('[data-hf-mobile-second-accordion]');
      if (!secondTrigger || !root.contains(secondTrigger)) return;
      if (window.innerWidth > 989) return;

      event.preventDefault();
      event.stopPropagation();
      toggleMobileSecondAccordion(secondTrigger);
    });
  })();
